<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="main-container">
          <div class="wrapper" style="min-width: 75%; margin-right: 16px;">
            <div class="row">
              <div class="col-8">
                <div class="row">
                  <div class="col-6">
                    <div class="form-group">
                      <label class="idx-bold" for="email-subject">
                        {{ $t('closetheloop.configureTemplate.emailSubject') }}
                      </label>

                      <input
                        type="text"
                        id="email-subject"
                        class="form-control"
                        :placeholder="
                          $t(
                            'closetheloop.configureTemplate.emailSubjectPlaceholder',
                          )
                        "
                        v-model="email.subject"
                      />
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label class="idx-bold" for="email-sender">
                        {{ $t('closetheloop.configureTemplate.emailSender') }}
                      </label>

                      <input
                        type="text"
                        id="email-sender"
                        class="form-control"
                        :placeholder="
                          $t(
                            'closetheloop.configureTemplate.emailSenderPlaceholder',
                          )
                        "
                        v-model="email.sender"
                      />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <wysiwyg
                      api-key="no-api-key"
                      license_key="gpl2"
                      tinymceScriptSrc="https://tinymce5.s3.amazonaws.com/tinymce/tinymce.min.js"
                      v-model="email.html"
                      :init="{
                        menubar: false,
                        statusbar: false,
                        height: 400,
                        language: $t('newAction.stepOne.editorLanguage'),
                        plugins: 'link image lists hr emoticons',
                        toolbar:
                          'bold italic underline | alignleft aligncenter alignright alignjustify | link image | forecolor backcolor | bullist numlist | fontselect fontsizeselect formatselect | emoticons | hr | lineheight | code',
                        lineheight_formats: '1 1.1 1.2 1.3 1.4 1.5 2',
                        font_formats:
                          'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Lato=Lato; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
                        image_description: false,
                        image_title: false,
                        content_style:
                          'img {max-width: 100%; max-height: 100%}',
                        image_dimensions: false,
                        file_picker_types: 'image',
                        images_upload_handler: imagesUploadHandlerBody,
                        relative_urls: false,
                        remove_script_host: false
                      }"
                    />
                  </div>
                </div>
              </div>

              <div class="col-4">
                <div
                  style="
                    border: 1px solid #c1c1c1;
                    border-radius: 5px;
                    padding: 16px;
                    height: 100%;
                  "
                >
                  <h5>Templates</h5>
                  <p>
                    {{
                      $t('closetheloop.configureTemplate.templateDescription')
                    }}
                  </p>

                  <br />

                  <h5>
                    {{ $t('closetheloop.configureTemplate.myTemplatesTitle') }}
                  </h5>
                  <p>
                    {{
                      $t(
                        'closetheloop.configureTemplate.myTemplatesDescription',
                      )
                    }}
                  </p>

                  <b-form-select
                    @change="handleTemplateSelected"
                    v-model="templateSelected"
                    :options="templateOptionsLean"
                  ></b-form-select>

                  <br />
                  <br />

                  <h5>
                    {{ $t('closetheloop.configureTemplate.saveTemplate') }}
                  </h5>
                  <div class="search-answers">
                    <input
                      type="text"
                      class="form-control"
                      id="input-template-name"
                      :placeholder="
                        $t(
                          'closetheloop.configureTemplate.saveTemplatePlaceholder',
                        )
                      "
                      v-model="newTemplateName"
                    />
                    <button
                      class="btn btn-outline-primary"
                      @click="handleSaveTemplate"
                    >
                      {{ $t('closetheloop.configureTemplate.saveButton') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="wrapper">
            <div class="row">
              <div class="col-12">
                <h5>{{ $t('closetheloop.configureTemplate.statusTitle') }}</h5>
                <p>
                  {{ $t('closetheloop.configureTemplate.statusDescription') }}
                </p>

                <b-form-group>
                  <b-form-radio
                    v-model="statusSelected"
                    name="status"
                    value="respondido"
                  >
                    {{ $t('treatments.statusSelect.answered') }}
                  </b-form-radio>
                  <b-form-radio
                    v-model="statusSelected"
                    name="status"
                    value="em_analise"
                  >
                    {{ $t('treatments.statusSelect.analysis') }}
                  </b-form-radio>
                  <b-form-radio
                    v-model="statusSelected"
                    name="status"
                    value="escalonada"
                  >
                    {{ $t('treatments.statusSelect.staggered') }}
                  </b-form-radio>
                  <b-form-radio
                    v-model="statusSelected"
                    name="status"
                    value="aberto"
                  >
                    {{ $t('treatments.statusSelect.opened') }}
                  </b-form-radio>
                </b-form-group>

                <hr />

                <h5>
                  {{ $t('closetheloop.configureTemplate.responsibleTitle') }}
                </h5>
                <p>
                  {{
                    $t('closetheloop.configureTemplate.responsibleDescription')
                  }}
                </p>

                <b-form-select
                  v-model="responsibleSelected"
                  :options="responsibleOptions"
                  disabled
                ></b-form-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 d-flex justify-content-between">
        <button class="btn btn-info" @click="step = 1">
          {{ $t('closetheloop.goBackButton') }}
        </button>
        <button class="btn btn-info" @click="handleNextStep">
          {{ $t('closetheloop.nextButon') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert';
import { mapFields } from 'vuex-map-fields';
import { mapState } from 'vuex';
import api from '../../../../services/api';

export default {
  data: () => ({
    userAuth: {},
    email: {
      subject: 'Retorno Equipe Experiência do Cliente',
      sender: null,
      html: null,
    },
    templateOptions: [],
    templateSelected: null,
    templateNameSelected: null,
    newTemplateName: null,
    statusSelected: 'em_analise',
    responsibleOptions: [],
    responsibleSelected: null,
  }),

  computed: {
    ...mapFields('closetheloop', ['step']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),

    templateOptionsLean() {
      return this.templateOptions.map((el) => ({
        value: el.value,
        text: el.text,
      }));
    },
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    this.responsibleOptions.push({
      value: this.userAuth._id,
      text: this.userAuth.name,
    });

    this.responsibleSelected = this.userAuth._id;

    await Promise.all([this.getTemplates()]);
  },

  methods: {
    async getTemplates() {
      const response = await api.get('/close-the-loop/templates', {
        headers: { 'x-access-token': this.userAuth.token },
      });

      this.templateOptions.push({
        value: null,
        text: this.$t('closetheloop.configureTemplate.selectTemplate'),
        subject: null,
        sender: null,
        html: null,
      });

      response.data.forEach((el) => {
        this.templateOptions.push({
          value: el._id,
          text: el.name,
          subject: el.subject,
          sender: el.sender,
          html: el.html,
        });
      });
    },

    async handleSaveTemplate() {
      if (!this.email.subject || !this.email.sender || !this.newTemplateName) {
        swal(
          'Oops...',
          this.$t('closetheloop.configureTemplate.saveErrorDescription'),
          'error',
        );
        return;
      }

      const response = await api.post(
        '/close-the-loop/templates',
        {
          name: this.newTemplateName,
          subject: this.email.subject,
          sender: this.email.sender,
          html: this.email.html,
        },
        {
          headers: { 'x-access-token': this.userAuth.token },
        },
      );

      swal(
        this.$t('closetheloop.configureTemplate.templatedCreatedTitle'),
        this.$t('closetheloop.configureTemplate.templatedCreatedDescription'),
        'success',
      );

      this.templateOptions.push({
        value: response.data._id,
        text: response.data.name,
        subject: response.data.subject,
        sender: response.data.sender,
        html: response.data.html,
      });

      this.templateSelected = response.data._id;

      this.templateNameSelected = response.data.name;

      this.newTemplateName = null;
    },

    async getResponsibles() {
      const response = await api.get('treatments/responsible-users', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
        },
      });

      response.data.forEach((el) =>
        this.responsibleOptions.push({ value: el._id, text: el.name }),
      );
    },

    async imagesUploadHandlerBody(blobInfo, success, failure) {
      if (!blobInfo) {
        return;
      }

      try {
        const formData = new FormData();

        formData.append('file', blobInfo.blob(), blobInfo.filename());

        const response = await api.post(
          '/close-the-loop/image-body',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              'x-access-token': this.userAuth.token,
            },
          },
        );

        success(response.data);
      } catch (error) {
        failure(error);
      }
    },

    handleTemplateSelected() {
      const template = this.templateOptions.find(
        (el) => el.value === this.templateSelected,
      );

      this.email.subject = template.subject;
      this.email.sender = template.sender;
      this.email.html = template.html;
      this.templateNameSelected = template.text;
    },

    handleNextStep() {
      if (!this.email.subject || !this.email.sender) {
        swal(
          'Oops...',
          this.$t('closetheloop.configureTemplate.errorDescription'),
          'error',
        );
        return;
      }

      this.$emit('input', {
        email: this.email,
        status: this.statusSelected,
        responsible: this.responsibleSelected,
        templateSelected: this.templateNameSelected || '-',
      });

      this.step = 3;
    },
  },

  watch: {
    '$i18n.locale': function watchLocale() {
      this.templateOptions[0].text = this.$t(
        'closetheloop.configureTemplate.selectTemplate',
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.main-container {
  display: flex;
  flex-direction: row;
}

.wrapper {
  background-color: $white;
  padding: 16px;
  border: 1px solid $gray-light;
  border-radius: 4px;
  flex: 1;
}

.search-answers {
  display: flex;
  flex-direction: row;

  input {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }

  button {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/closetheloop/configure-template/index.vue